import './style.css';
import React from 'react';
import { ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { personFullName } from "../../../../services/Api";
import SelectAsync from 'react-select/lib/Async';
import _ from "lodash";
import PropTypes from "prop-types";
import { CertificatesListSGroups } from '../../utils/CertificatesListSGroups';

class AddEmittedCertificate extends React.Component {

    static contextTypes = { api: PropTypes.object, notifier: PropTypes.object };

    constructor(props) {
        super(props);
        const person = props.person;
        this.state = {
            form: {
                member: personFullName(person)
            },
            showValidator: false,
            containsTemplate: false
        };
        this.loadCertificates = _.debounce(this.loadCertificates, 250);
    }

    onFileChange = ({ target }) => {
        if (target.files.length){
            this.setState({ file: target.files[0] });
        }
        else this.setState({ file: undefined });
    };

    onFormChange = ({ target }) => {
        this.setState({ form: { ...this.state.form, [target.name]: target.value } });
        this.setState({ containsTemplate: target.value.file === null ? false : true });
        this.setState({ showValidator: true });
    }

    loadCertificates = (name) => {
        return this.context.api.certificates.get(0, 10, undefined, { name: name, sGroups: CertificatesListSGroups })
            .then((certificates = []) => certificates.map((certificate) => ({ value: certificate.id, label: certificate.name, file: certificate.templateFile })))
    };

    getFormValue = (name) => {
        return this.state.form[name] ? this.state.form[name] : '';
    };

    saveCertificateAssignation = () => {
        if (!this.state.form.certificate)
            return this.context.notifier.error('Debes introducir el certificado a asignar');

        if (!this.state.containsTemplate) {
            if (!this.state.file)
                return this.context.notifier.error('Falta archivo');
        }

        const assignation = {
            "sGroups": CertificatesListSGroups,
            "person": this.props.person.id,
            "certificate": this.state.form.certificate.value
        };

        if(this.state.file)
            this.context.api.emittedCertificates.create( assignation, undefined, this.state.file).then(this.finish);
        else
            this.context.api.emittedCertificates.create(assignation, undefined).then(this.finish);
    };

    finish = () => {
        if (this.props.didSave) { this.props.didSave(); }
        this.props.onHide();
    };

    render() {
        const { onHide } = this.props;

        return (
            <Modal
                show={true}
                onHide={onHide}
                className="AddEmittedCertificateModal"
            >


                <Modal.Header closeButton>
                    <Modal.Title>{'Añadir  constancia a miembro'}</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <p><b>Miembro:</b> {this.getFormValue('member')}</p>

                    <div className="from-group">
                        <label>Seleccionar constancia:</label>
                        <SelectAsync
                            cacheOptions
                            placeholder='Escribe el nombre de una constancia'
                            noOptionsMessage={() => "Sin coincidencias"}
                            loadOptions={this.loadCertificates}
                            onChange={(value) => this.onFormChange({ target: { name: "certificate", value } })}
                        />
                    </div>
                    {
                        this.state.showValidator ?
                            !this.state.containsTemplate
                                ? (
                                    <FormGroup className="add-template">
                                        <p>La constancia seleccionada <strong>no</strong> cuenta con una plantilla. Añade la constancia completa.</p>
                                        <ControlLabel>Agregar archivo:</ControlLabel>
                                        <FormControl type='file' onChange={this.onFileChange} />
                                    </FormGroup>
                                )
                                : (<p className="contains-template-info">La constancia seleccionada cuenta con una plantilla. Procede a guardar los cambios para asignar satisfactoriamente la constancia.</p>)
                            : null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.props.onHide} className='btn btn-primary pull-left'>Cancelar</button>
                    <button className='btn btn-danger' onClick={this.saveCertificateAssignation}>Añadir</button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = ({ api: { certificates = [], simplePeople = [] }, loadingIds }) => ({ simplePeople, certificates, loadingIds });

export default connect(mapStateToProps)(AddEmittedCertificate);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/AddEmittedCertificateModal/index.jsx